<template>
  <div>
    <password-modal />
  </div>
</template>

<script>
import PasswordModal from '@/components/actions/PasswordModal.vue';

export default {
  name: 'actions',
  components: {
    PasswordModal,
  },
};
</script>
